import React from "react";
import { FiUsers } from "react-icons/fi";

export default function AssociationsEmptyState() {
  return (
    <div className="flex min-h-[280px] items-center justify-center p-8">
      <div className="max-w-md text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-[1.5rem] bg-slate-100 text-3xl text-slate-400 dark:bg-slate-800 dark:text-slate-500">
          <FiUsers />
        </div>

        <h3 className="mt-5 text-xl font-bold text-slate-950 dark:text-white">
          Aucune association trouvée
        </h3>

        <p className="mt-2 text-sm leading-6 text-slate-500 dark:text-slate-400">
          Modifiez les filtres ou créez une nouvelle association pour alimenter
          l’annuaire communal.
        </p>
      </div>
    </div>
  );
}